export default {
  /**
   * 判断当前单据是否展示「撤回单据」按钮
   * @param approvalHistorys 审批历史 list
   * @param formWithdrawAuthority 工作流撤回设置的值
   */
  isRecallAvailable(approvalHistorys, formWithdrawAuthority) {
    // 没有审批历史时不展示「撤回单据」按钮
    if (!approvalHistorys || (approvalHistorys && approvalHistorys.length === 0)) {
      return false;
    } else {
      const submitNodeIndex = approvalHistorys.findIndex((item) => item.operation === 1001);
      // 仅校验最新一次提交的审批历史记录
      approvalHistorys = approvalHistorys.slice(0, submitNodeIndex + 1);
      // 审批历史中是否存在审批通过节点
      const hasApprovePassNode = approvalHistorys.some((item) => item.operation === 2001);
      // 审批历史中是否存在审核通过节点
      const hasAuditPassNode = approvalHistorys.some((item) => item.operation === 3001);
      // 审批历史中是否存在管理员管理员当前审批通过
      const hasAdminApprovePassNode = approvalHistorys.some(
        (item) => item.operation === 2019 && item.nodeType === 1001
      );
      // 审批历史中是否存在管理员管理员当前审核通过
      const hasAdminAuditPassNode = approvalHistorys.some((item) => item.operation === 2019 && item.nodeType === 1012);
      if (
        formWithdrawAuthority === '0' ||
        (formWithdrawAuthority === '2' &&
          (hasApprovePassNode || hasAuditPassNode || hasAdminApprovePassNode || hasAdminAuditPassNode)) ||
        (formWithdrawAuthority === '3' && (hasApprovePassNode || hasAdminApprovePassNode)) ||
        (formWithdrawAuthority === '4' && (hasAuditPassNode || hasAdminAuditPassNode))
      ) {
        return false;
      }
      return true;
    }
  },
};
